import React, { useEffect, useState } from "react";
import { Modal } from 'antd';
import { useMobile } from "@/hooks/use-mobile";

const MobileNotify = (props) => {
  const [hasShown, setHasShown] = useState(false);
  const { isMobile } = useMobile();

  useEffect(() => {
    if (hasShown) return;
    if (!isMobile || !/new|errors/.test(props.location.pathname)) return;
    setHasShown(true);
    Modal.info({
      title: '提示',
      content: '该页面为PC端操作页面，您当前在移动端使用会有定位/实拍等功能限制，影响提报。如需在移动端使用可前往app提报。',
      onOk() {},
    });
  }, [isMobile, props.location.pathname])

  return (
    <>{props.children}</>
  )
}

export default MobileNotify
